import React from 'react'
import social from '../constants/social.json'
import BreakLiner from '../utils/BreakLiner'
import logo_gray from '../assets/images/logo/logo_gray_left.svg';
import { Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, ScopedCssBaseline, ThemeProvider, Typography } from '@mui/material'
import { darkTheme } from '../assets/styles/theme';

function Footer() {
  return (
  <ThemeProvider theme={darkTheme}>
    <ScopedCssBaseline sx={{display:'flex', justifyContent:'center', backgroundColor:'var(--dark)'}}>
      <Grid container
        component="footer"
        justifyContent='space-between'
        alignItems="center"
        sx={{ pl:4, pt:2, maxWidth:1360 }}
        columnSpacing={{xs:2, md:4}}
      >
        <Grid item xs={11} sm={3} md={2}>
          <img src="images/qr_at_dir.png" alt="qr" className="qr" />
        </Grid>
        <Grid item xs={11} sm={9} md={6}>
          <Typography variant='h4'>Información de contacto</Typography>
          <List>
            {social.map( sm => (
              <ListItem key={sm.title} disablePadding className="conn">
                <ListItemButton href={sm.href} target="_blank">
                  <ListItemIcon className={`fas fa-${sm.icon}`}/>
                  <ListItemText primary={ <BreakLiner text={sm.title}/> }/>
                </ListItemButton>
              </ListItem>
            ) )}
          </List>
        </Grid>
        <Grid item xs={11} sm={8} md={4}>
          <img src={logo_gray} alt="logo" className='logo'/>
        </Grid>
      </Grid>
    </ScopedCssBaseline>
  </ThemeProvider>
  )
}

export default Footer